interface Props {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
}

export default function SectionHeading({ eyebrow, title, desc, align = 'left' }: Props) {
  const center = align === 'center';
  return (
    <div className={`max-w-2xl ${center ? 'mx-auto text-center' : ''}`}>
      {eyebrow && (
        <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-900">
          <i className="ri-sparkling-2-fill text-secondary-600"></i>
          {eyebrow}
        </span>
      )}
      <h2 className={`mt-4 text-2xl font-bold tracking-tight text-foreground-950 md:text-[2rem] md:leading-tight ${center ? '' : ''}`}>
        {title}
      </h2>
      {desc && (
        <p className={`mt-3 text-base leading-relaxed text-foreground-600 ${center ? 'mx-auto' : ''}`}>
          {desc}
        </p>
      )}
    </div>
  );
}